<!-- <div class="p-3 space-y-4">
  <div class="d-flex justify-content-between my-4 mx-3">
     <div class="row">
    <h5>Form DPR - <span class="text-primary"> [{{proposalName}}]</span></h5>
    <h6><span class="text-primary"> [
                            {{
                            stepDetails?.step_status == 0
                            ? 'INITIATION PENDING'
                            : (stepDetails?.step_status | uppercase)
                            }}
                            ]</span></h6>
                </div>
    <div class="d-flex gap-2">
      
        <p-button label="Next" icon="pi pi-angle-right" iconPos="right" (onClick)="goToNextStep()"
                [outlined]="true" *ngIf="stepDetails?.step_status == 'approved'"></p-button>
      <ng-container *ngIf="stepDetails">
        <p-button *ngIf="stepDetails.is_initiator" label="Initiate" icon="pi pi-play" (onClick)="IRA.emit('Initiate')"
          [outlined]="true"></p-button>
        <p-button *ngIf="stepDetails.is_approver" label="Approve" icon="pi pi-check-circle"
          (onClick)="IRA.emit('Approve')" [outlined]="true"></p-button>
        <p-button *ngIf="stepDetails.is_recommender" label="Recommend" icon="pi pi-thumbs-up"
          (onClick)="IRA.emit('Recommend')" [outlined]="true"></p-button>
      </ng-container>

    </div>
  </div>
  <hr>

<p-accordion [multiple]="false">
    <ng-container *ngFor="let vendor of vendors; let i = index">
        <p-accordionTab>
            <ng-template pTemplate="header">
                <div class=" rounded-top d-flex justify-content-between align-items-center gap-2 w-100">
                    <span class="font-bold whitespace-nowrap">{{ vendor.name }}</span>
                    <div class="d-flex gap-2 align-items-center">
                        <p-badge value="Qualified EOI" severity="info" class="ml-auto mr-2"></p-badge>
                        @if (activeIndex === i) {
                            <i class="pi pi-minus"></i>
                        } @else {
                            <i class="pi pi-plus"></i>
                        }
                    </div>
                </div>
            </ng-template>

            <div class="vendor-criteria-table m-3">
                <p-table [value]="vendor.entries" styleClass="p-datatable-sm">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="wid-5-percent">S.No</th>
                            <th class="wid-75-percent">Criteria</th>
                            <th class="wid-10-percent" *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| (stepDetails?.step_status != 'approved' && userID == 6)">Upload</th>
                            <th class="wid-10-percent">View</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-criteria>
                        
                        <tr>
                            <td>1.</td>
                            <td>DPR</td>
                            <td *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| (stepDetails?.step_status != 'approved' && userID == 6)">
                                <div class="d-flex gap-2 align-items-center">
                                    <p-fileUpload mode="basic" chooseLabel="Upload" [auto]="true" customUpload="true"
                                        styleClass="p-button-sm p-button-outlined" (onSelect)="onFileSelect($event, criteria, 'dpr')">
                                    </p-fileUpload>

                                    <button *ngIf="criteria.selectedDPRFile" pButton label="Submit" icon="pi pi-check"
                                        class="p-button-sm p-button-success fetch-data-btn" (click)="submitDocument(vendor, criteria, 'dpr')">
                                    </button>
                                </div>

                                <div *ngIf="criteria.selectedDPRFile" class="mt-1 text-truncate max-wid-200">
                                    <small>Selected File: {{ criteria.selectedDPRFile.name }}</small>
                                </div>
                            </td>
                            <td>
                                <a [href]="apiUrl + criteria.document" target="_blank" *ngIf="criteria.document"
                                    rel="noopener noreferrer">
                                    
                                       <p-button icon="pi pi-eye" styleClass="p-button-sm p-button-outlined" pTooltip="View Document">
                                        </p-button>
                                </a>
                            </td>
                        </tr>

                        
                        <tr>
                            <td>2.</td>
                            <td>Bid Document</td>
                            <td *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| (stepDetails?.step_status != 'approved' && userID == 6)">
                                <div class="d-flex gap-2 align-items-center">
                                    <p-fileUpload mode="basic" chooseLabel="Upload" [auto]="true" customUpload="true"
                                        styleClass="p-button-sm p-button-outlined" (onSelect)="onFileSelect($event, criteria, 'bid')">
                                    </p-fileUpload>

                                    <button *ngIf="criteria.selectedBidFile" pButton label="Submit" icon="pi pi-check"
                                        class="p-button-sm p-button-success fetch-data-btn" (click)="submitDocument(vendor, criteria, 'bid')">
                                    </button>
                                </div>

                                <div *ngIf="criteria.selectedBidFile" class="mt-1 text-truncate max-wid-200">
                                    <small>Selected File: {{ criteria.selectedBidFile.name }}</small>
                                </div>
                            </td>
                            <td>
                                <a [href]="null" class="disabled-link" target="_blank" *ngIf="criteria.bid_document"
                                    [attr.disabled]="true" rel="noopener noreferrer">
                                    <i class="pi pi-eye" styleClass="p-button-sm p-button-outlined"></i>
                                </a>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </p-accordionTab>
    </ng-container>
</p-accordion>
</div> -->


<div class="container-fluid p-3">

  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1" *ngIf="schemeType == 'tdf'">{{ format == 'upload' ? 'Firm Response Evaluation' : 'Firm Response Submission'}}</h4>
        <h4 class="mb-1" *ngIf="schemeType == 'tdf'">{{ format == 'upload' ? 'Evaluation of DPR' : 'Upload DPR'}}</h4>
        <h5 class="text-primary">[{{ proposalName }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
       

        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container *ngIf="
            stepDetails?.is_initiator ||
            stepDetails?.is_approver ||
            stepDetails?.is_recommender ||
            (stepDetails?.step_status != 'approved' && userID == 6)
          ">
          <!-- <button
            class="btn btn-primary me-2"
            (click)="onSubmit()"
            [disabled]="RFPForm.invalid"
          >
            <i class="pi pi-save me-1"></i> Submit
          </button> -->
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_initiator">
          <button class="btn btn-success" (click)="IRA.emit('Initiate')">
            <i class="pi pi-play me-1"></i> Initiate
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_approver">
          <button class="btn btn-success" (click)="IRA.emit('Approve')">
            <i class="pi pi-check-circle me-1"></i> Approve
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_recommender">
          <button class="btn btn-info" (click)="IRA.emit('Recommend')">
            <i class="pi pi-thumbs-up me-1"></i> Recommend
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />
  <div class="card shadow-sm border-0 p-4">

    <p-accordion>
      <p-accordionTab *ngFor="let row of winners; let i = index">
         <ng-template pTemplate="header">
        <div class="d-flex justify-content-between align-items-center" style="width: 100%">
          <div>
            <strong>{{ row.vendor.name }}  </strong>
            <span *ngIf="row.vendor_status && format == 'upload'" class="p-ml-2" [ngClass]="{
                  'text-success': row.vendor_status === 'Qualified' || row.vendor_status === 'Qualify',
    'text-danger': row.vendor_status === 'Disqualified' || row.vendor_status === 'Disqualify'
                }">
             - ({{ row.vendor_status === 'Qualify' ? 'Qualified' : 
         row.vendor_status === 'Disqualify' ? 'Disqualified' : row.vendor_status }})
            </span>
          </div>
          <div class="d-flex gap-3" *ngIf="format =='upload' ">
            <button class="p-button-success p-mr-2" (click)="setStatus(row, 'Qualify')"> Qualify </button>
            <button class="p-button-danger" (click)="setStatus(row, 'Disqualify')"> Disqualify</button>
          </div>
        </div>
      </ng-template>

        <div class="row mb-4">
          <div class="col-lg-8">
            <div class="card shadow-sm border-0">
              <div class="card-body p-4">
                <div class="d-flex align-items-center mb-3">
                  <i class="pi pi-file text-primary me-2"></i>
                  <h5 class="card-title mb-0">Vendor Document</h5>
                </div>

                <p class="text-muted mb-4">
                  Please upload your document in PDF, DOCX, CSV, JPEG, JPG, or PNG format (Max size: 200MB)
                </p>

                <!-- Upload Area -->
                <!-- <div class="upload-container mb-4"
                  *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender || (stepDetails?.step_status != 'approved' && userID == 6)">
                  <div class="upload-area p-4 text-center border rounded">
                    <p-fileUpload #fileUpload mode="basic" chooseLabel="Browse Files" [auto]="true"
                      [customUpload]="true" [multiple]="schemeType === 'tdf'" name="files[]"
                      [accept]="'.pdf,.docx,.csv,.jpeg,.jpg,.png'" [maxFileSize]="209715200"
                      (onSelect)="onMultipleFileUpload($event, row)">
                    </p-fileUpload>

                    
                    <button class="btn btn-sm btn-primary mt-3"
                        (click)="saveRow(row)">
                  <i class="pi pi-upload me-1"></i> Upload
                </button>
                    
                    <ng-container *ngIf="row.tempDocuments && row.tempDocuments.length > 0">
                      
                      <ul class="list-unstyled">
                        <li *ngFor="let file of row.tempDocuments">
                          {{ file.name }}
                        </li>
                      </ul>

                      <button class="btn btn-sm btn-primary mt-2" (click)="saveRow(row)">
                        <i class="pi pi-upload me-1"></i> Upload
                      </button>
                    </ng-container>

                    
                    <ng-container *ngIf="(!row.documents?.length && !row.tempDocuments?.length)">
                      <span class="text-muted">No documents uploaded</span>
                    </ng-container>
                  </div>
                </div> -->

                <app-upload-document>
                </app-upload-document>
                
                <div *ngIf="!row.documents?.length" class="no-file-placeholder p-3 text-center bg-light rounded">
                  <i class="pi pi-inbox text-muted mb-2" style="font-size: 1.5rem;"></i>
                  <p class="mb-0 text-muted">No files uploaded</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <!-- Already Uploaded -->
          <ng-container *ngIf="row.documents && row.documents.length > 0">
            <h6 class="text-success">Uploaded Files</h6>
            <ul class="list-unstyled">
              <li *ngFor="let doc of row.documents">
                <a [href]="baseUrl + doc.fileId" [attr.download]="doc.fileName" target="_blank">
                  {{ doc.fileName }}
                </a>
              </li>
            </ul>
          </ng-container>

        </div>
      </p-accordionTab>
    </p-accordion>

  </div>

</div>